module.exports = __webpack_public_path__ + "img/company3_1.061e7df5.png";